export const details = [
  { label: "User Type", property: "usertype" },
  { label: "First Name", property: "firstname" },
  { label: "Last Name", property: "lastname" },
  { label: "Sex", property: "gender" },
  { label: "Phone Number", property: "phonenumber" },
  { label: "Email", property: "email" },
  { label: "User Level", property: "userlevel" },
  { label: "TRE Affiliation", property: "establishments" },
];
